import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "BuildingInsights2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.125 9C2.67525 9 1.5 7.82475 1.5 6.375C1.5 4.92525 2.67525 3.75 4.125 3.75H4.59525C4.93865 2.42636 6.13254 1.50158 7.5 1.5H9V3H7.5C6.67192 3.00083 6.00083 3.67192 6 4.5V5.25H4.125C3.50368 5.25 3 5.75368 3 6.375C3 6.99632 3.50368 7.5 4.125 7.5H9V9H4.125ZM15 6H13.5V7.5H15V6ZM19.5 6H18V7.5H19.5V6ZM13.5 10.5H15V12H13.5V10.5ZM19.5 10.5H18V12H19.5V10.5ZM13.5 15H15V16.5H13.5V15ZM19.5 15H18V16.5H19.5V15ZM12 1.5H21C21.8281 1.50083 22.4992 2.17192 22.5 3V22.5H1.5V12C1.50083 11.1719 2.17192 10.5008 3 10.5H10.5V3C10.5008 2.17192 11.1719 1.50083 12 1.5ZM6.75 21V15.75H9.75V21H6.75ZM11.25 21H21V3H12V12H3V21H5.25V15C5.25 14.5858 5.58579 14.25 6 14.25H10.5C10.9142 14.25 11.25 14.5858 11.25 15V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/BuildingInsights2.vue"]]);
